﻿import { FIQAssist } from "../app";
import { Component, Attribute, Output, Input } from "@fiqas/angular-utils";

@Component({
    module: FIQAssist,
    selector: 'pushicon',
    template: `<div class="pushicon ng-class:{isfocus:$ctrl.isfocus, enabled:$ctrl.enabled}" tabindex="0" ng-click="$ctrl.onClick($event)" ng-keydown="$ctrl.onKey($event)" 
                    ng-focus="$ctrl.onFocus()" ng-blur="$ctrl.onBlur()" style="width:100%;height:100%">
                <span class="icon ng-class:$ctrl.icon"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>
            </div>`
})
export class Pushicon {
    @Attribute() public icon: string;
    @Attribute() public link: string;
    @Attribute() public arrow: 'none' | 'left' | 'right';

    @Input() enabled: boolean;

    @Output()
    public onclicked: () => void;

    public $onInit() {
        if (this.enabled === undefined)
            this.enabled = true;
    }

    public onClick(event: Event) {
        event.preventDefault();
        if (this.enabled)
            this.onclicked();
    }

    public onKey(event: KeyboardEvent) {
        if (event.keyCode == 32 || event.keyCode == 13) {
            event.preventDefault();
            if (this.enabled)
                this.onclicked();
        }
    }

    private isfocus: boolean = false;

    public onFocus() {
        this.isfocus = true;
    }

    public onBlur() {
        this.isfocus = false;
    }
}
